import { AppStorage } from '@/core/utils/app.storage';
import { AppStorageService } from '@/core/utils/app.storage.service';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { forkJoin, from, map, Observable, of, switchMap } from 'rxjs';

import enDevExtreme from '@a/i18n/devextreme/en.json';
import esDevExtreme from '@a/i18n/devextreme/es.json';

import enForms from '@a/i18n/forms/en.json';
import esForms from '@a/i18n/forms/es.json';

import enMessages from '@a/i18n/messages/en.json';
import esMessages from '@a/i18n/messages/es.json';

import enGeneral from '@a/i18n/pages/general/en.json';
import esGeneral from '@a/i18n/pages/general/es.json';

import enPharma from '@a/i18n/pharma/en.json';
import esPharma from '@a/i18n/pharma/es.json';

import enPrimeNg from '@a/i18n/primeng/en.json';
import esPrimeNg from '@a/i18n/primeng/es.json';

import enProductivity from '@a/i18n/productivity/en.json';
import esProductivity from '@a/i18n/productivity/es.json';

import enTitles from '@a/i18n/titles-and-headings/en.json';
import esTitles from '@a/i18n/titles-and-headings/es.json';

import enGlobal from '@a/i18n/en.json';
import esGlobal from '@a/i18n/es.json';

export class MultiTranslateRootLoader implements TranslateLoader {
  private translations: { [key: string]: any } = {
    devExtreme: {
      en: enDevExtreme,
      es: esDevExtreme,
    },
    forms: {
      en: enForms,
      es: esForms,
    },
    messages: {
      en: enMessages,
      es: esMessages,
    },
    general: {
      en: enGeneral,
      es: esGeneral,
    },
    pharma: {
      en: enPharma,
      es: esPharma,
    },
    primeNg: {
      en: enPrimeNg,
      es: esPrimeNg,
    },
    productivity: {
      en: enProductivity,
      es: esProductivity,
    },
    titles: {
      en: enTitles,
      es: esTitles,
    },
    global: {
      en: enGlobal,
      es: esGlobal,
    },
  };

  constructor(private readonly storage: AppStorageService) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    const typeObservable = from(this.storage.get(AppStorage.COMPANY_TYPE)).pipe(
      switchMap((type) => forkJoin([of((this.translations[type ?? 'pharma'] ?? this.translations['pharma'])[lang])])),
      map((res) => res[0]),
    );

    return forkJoin([
      of(this.translations['global'][lang]),
      of(this.translations['general'][lang]),
      of(this.translations['titles'][lang]),
      of(this.translations['primeNg'][lang]),
      of(this.translations['devExtreme'][lang]),
      of(this.translations['forms'][lang]),
      of(this.translations['messages'][lang]),
      typeObservable,
    ]).pipe(map((response) => response.reduce((accumulate, current) => ({ ...accumulate, ...current }))));
  }
}
